import Player from '@vimeo/player';

window.addEventListener('livewire:init', function () {
  const dashboardWelcomeVideoComponent = document.querySelector('.dashboard-welcome-video-component');
  const vimeoIframe = dashboardWelcomeVideoComponent?.querySelector('[data-dashboard-welcome-video] iframe');

  if (!vimeoIframe) {
    return;
  }

  const hideButton = dashboardWelcomeVideoComponent.querySelector('[data-dashboard-welcome-video-control=hide]');
  const content = dashboardWelcomeVideoComponent.querySelector('[data-dashboard-welcome-video-content]');
  const videoControlsContainer = dashboardWelcomeVideoComponent.querySelector('[data-dashboard-welcome-video-controls]');
  const filter = dashboardWelcomeVideoComponent.querySelector('[data-dashboard-welcome-video-filter]');

  const videoType = dashboardWelcomeVideoComponent.dataset.dashboardWelcomeVideoType;

  const player = new Player(vimeoIframe);

  if (!storage.isSet(`hide-dashboard-welcome-video-${videoType}`)) {
    dashboardWelcomeVideoComponent.classList.remove('d-none');
  }

  hideButton.addEventListener('click', function () {
    player.pause();

    // remove the video from the dom
    dashboardWelcomeVideoComponent.remove();

    // $('.dashboard-welcome-video-component').addClass('d-none');
    storage.set(`hide-dashboard-welcome-video-${videoType}`, true);
  });

  videoControlsContainer.addEventListener('click', async function () {
    // const paused = await player.getPaused();

    playVideo();

    videoControlsContainer.classList.add('pointer-events-none');
    filter.remove();
    content.remove();
  }, {once: true});

  function playVideo() {
    content.classList.add('opacity-0');
    filter.classList.add('opacity-0');

    togglePlayPauseIcons(true);

    setTimeout(function () {
      player.play();
    }, 500);
  }

  // function pauseVideo() {
  //   player.pause();
  //
  //   content.classList.remove('opacity-0');
  //   filter.classList.remove('opacity-0');
  //
  //   togglePlayPauseIcons(false)
  // }

  function togglePlayPauseIcons(play = true) {
    const playIcons = videoControlsContainer.querySelectorAll('[data-play-icon]');
    const pauseIcons = videoControlsContainer.querySelectorAll('[data-pause-icon]');

    if (!play) {
      playIcons.forEach(function (icon) {
        if (icon.classList.contains('d-none')) {
          icon.classList.remove('d-none');

        }
      });

      pauseIcons.forEach(function (icon) {
        if (!icon.classList.contains('d-none')) {
          icon.classList.add('d-none');
        }
      });
    } else {
      playIcons.forEach(function (icon) {
        if (!icon.classList.contains('d-none')) {
          icon.classList.add('d-none');
        }
      });

      pauseIcons.forEach(function (icon) {
        if (icon.classList.contains('d-none')) {
          icon.classList.remove('d-none');
        }
      });
    }
  }
});
